import styled from 'styled-components';

const WraperGroupAuthVariant = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
`;

const ItemAuth = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  flex: 1;
`;

const Divider = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  margin: 24px 0 16px;
`;

const DividerLine = styled.div`
  flex: 1;
  height: 1px;
  background-color: #afafaf; // или ваш цвет из дизайн-системы
  opacity: 0.3;
`;

const DividerText = styled.div`
  padding: 0 12px;
`;

const HiddenGoogleButton = styled.div`
  display: none;
`;
export {
  WraperGroupAuthVariant,
  ItemAuth,
  Divider,
  DividerLine,
  DividerText,
  HiddenGoogleButton,
};
